import produce from 'immer';

import * as actions from './actions';

export const defaultState = {
    isLoading: true,
    topWinners: []
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case actions.SET_TOP_WINNERS_DATA:
        case actions.SET_TOP_WINNERS_DATA + reducerSuffix: {
            Object.assign(draftState, {
                topWinners: action.payload
            });

            break;
        }

        case actions.TOGGLE_LOADING:
        case actions.TOGGLE_LOADING + reducerSuffix: {
            Object.assign(draftState, {
                isLoading: action.payload
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
